<template>
  <!-- 首页 - 开始页面 -->
  <div class="min-h-screen flex items-center justify-center relative bg-gradient-to-br">
    <!-- 跳过链接 - 可访问性 -->
    <a href="#main-content" class="skip-link">Skip to main content</a>

    <!-- 背景装饰 -->
    <div class="absolute inset-0 -z-10">
      <div class="absolute inset-0 bg_leaves"></div>
    </div>
    <div class="absolute inset-0 -z-10">
      <div class="absolute inset-0 bg_link"></div>
    </div>

    <!-- 主要内容区 -->
    <div class="text-center max-w-2xl px-6 z-10 fade-in w-full">
      <!-- 首页内容 -->
      <!-- 机构Logo -->
      <div class="mb-2">
        <!-- <div class="w-20 mx-auto flex items-center justify-center text-6xl font-bold ">
          VerdeX
        </div>
        <div class="text-lg">
          CARBON EXCHANGE
        </div> -->
        <img class="w-60 mx-auto" src="../assets/airlogo.png"/>
      </div>

      <!-- 欢迎内容 -->
      <div class="mb-10 flex items-center flex-col">
        <div class="w-60 mb-2 pl-4 text-left text-2xl text-blue-900">
          Empowering the  
        </div>
        <div class="w-60 mb-2 pl-4 text-left text-2xl text-blue-900">
          Global Carbon
        </div>
        <div class="w-60 mb-2 pl-4 text-left text-2xl text-blue-900">
          Market
        </div>
      </div>

      <!-- 地图 -->
      <div class="mb-10 flex items-center justify-center">
         <img class="w-60 absolute" style="z-index: -1;" src="../assets/images/map.png">
         <div class="text-left">
            <div class="text-2xl">165,824,370</div>
            <div style="font-size: 0.75rem;line-height: 1.25rem;">Total Credits transacted</div>
            <img class="w-40" src="../assets/images/first_vcs.png">
            <img class="w-40" src="../assets/images/first_gs.png">
         </div>
      </div>

      <!-- 操作按钮组 -->
      <div class="flex flex-col gap-4 justify-center mb-6 max-w-sm mx-auto">
        <router-link to="/login"
          class="btn btn-primary btn-large btn-full-gree w-full hover:-translate-y-0.5 transition-transform">
          Corporate Login
        </router-link>

        <router-link to="/login"
          class="btn btn-primary btn-large btn-full-gree w-full hover:-translate-y-0.5 transition-transform">
          Personal Login
        </router-link>

        <router-link to="/register"
          class="btn  btn-secondary btn-large btn-white w-full hover:-translate-y-0.5 transition-transform">
          Create Account
        </router-link>

        <!-- <div @click="openLiveChat">
          Forgot password ?
        </div> -->

      </div>

      <!-- 底部说明文字 -->
      <div class="text-gray-500">
        <p class="text-sm">
          Join thousands of individuals taking climate action
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// 首页组件 - 现在由预加载屏幕处理认证检查和导航逻辑
// 这里只需要显示登录和注册选项

import { useMessage } from 'naive-ui'
const message = useMessage()

// 打开LiveChat的方法 - 使用原生LiveChat
const openLiveChat = async () => {
  try {
    console.log('尝试打开LiveChat...')

    // 获取配置
    const response = await fetch('/api/livechat/config')
    if (!response.ok) {
      throw new Error('无法获取LiveChat配置')
    }

    const data = await response.json()
    const config = data.data || data

    if (!config.enabled || !config.license_id) {
      message.warning('Customer service function is temporarily unavailable')
      return
    }

    // 设置LiveChat配置
    window.__lc = window.__lc || {}
    window.__lc.license = config.license_id
    if (config.group_id) {
      window.__lc.group = config.group_id
    }

    // 如果SDK还没有加载，加载它（帶超時保護）
    if (!window.LC_API) {
      const script = document.createElement('script')
      script.src = 'https://cdn.livechatinc.com/tracking.js'
      script.async = true

      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error('LiveChat SDK 加載超時'))
        }, 15000)

        script.onload = () => {
          const startTime = Date.now()
          const checkAPI = () => {
            if (window.LC_API) {
              clearTimeout(timeout)
              resolve(true)
            } else if (Date.now() - startTime > 10000) {
              clearTimeout(timeout)
              reject(new Error('LiveChat API 初始化超時'))
            } else {
              setTimeout(checkAPI, 200)
            }
          }
          checkAPI()
        }
        script.onerror = () => {
          clearTimeout(timeout)
          reject(new Error('LiveChat SDK 加載失敗'))
        }
        document.head.appendChild(script)
      })
    }

    // 打开聊天窗口
    window.LC_API.open_chat_window()

    console.log('LiveChat打开成功')

  } catch (error) {
    console.error('打开LiveChat失败:', error)
    message.error('The customer service system is temporarily unavailable, please try again later.')
  }
}

</script>